// extracted by mini-css-extract-plugin
export default {"fadeInBottom":"ScrollingAnimations_fadeInBottom__YPXi8","isVisible":"ScrollingAnimations_isVisible__rbQcv"};